<template>
  <transition-group
    tag="div"
    name="t-win-feed-item"
    class="win-feed d-flex"
  >
    <slot v-for="item in feed" :item="item">
      <WinFeedItem :key="item.id" :item="item" />
    </slot>
  </transition-group>
</template>

<script>
import { mapGetters } from 'vuex'
import WinFeedItem from './WinFeedItem'

export default {
  components: {
    WinFeedItem,
  },
  computed: {
    ...mapGetters({
      feed: 'winfeed/feed',
    }),
  },
}
</script>

<style lang="scss" scoped>

.win-feed {
  overflow-x: hidden;

  // default comp
  .win-feed-item {
    min-width: 120px;
    max-width: 120px;
  }

  ::v-deep .win-feed-item {
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
}

::v-deep .t-win-feed-item {
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateX(-100%);
  }

  &-enter-to {
    opacity: 1;
  }
}
</style>
